import { useMutation } from '@tanstack/react-query';
import { patch } from 'api/base';
import type { AnamnesisSummaryContent } from 'types/anamnesis';

export type AnamnesisSeenParams = Pick<AnamnesisSummaryContent, 'seen'>;

export function useSetAnamnesisSeen() {
  return useMutation({
    mutationFn: async ({ data, id }: { data: AnamnesisSeenParams; id: string }) => {
      return patch('setAnamnesisSeen', data, id) as Promise<AnamnesisSummaryContent>;
    },
  });
}
